import {
  Box,
  Button,
  Flex,
  Header,
  Icon,
  Link,
  Modal,
  Skeleton,
  StatusBadge,
} from '@driftt/dds'
import { bot } from '@driftt/dds.icons/custom/bot'
import { faCube } from '@driftt/dds.icons/light/faCube'
import React from 'react'

import { useContentVariableUsage } from 'hooks/useContentVariables'
import { isEmptyOrNil, uniqueId } from 'utils/index'

import './style.css'

const parseContentVarStringToHtml = (sentence, variableName) => {
  const jinjaRegex = /(?<={{)(.*?)(?=}})/g
  const splitMessage = sentence.split(jinjaRegex)
  if (isEmptyOrNil(splitMessage)) {
    return sentence
  }
  return splitMessage
    .map((subString) => {
      if (subString.includes('{{') || subString.includes('}}')) {
        return subString.replace('{{', ' ').replace('}}', ' ')
      }
      if (subString.includes('contentVariable')) {
        return `<span class="content-var--pill-container">${variableName}</span>`
      }
      return subString
    })
    .join('')
}

const ContentVariableUsageModal = ({ variable, isOpen = false, onClose }) => {
  const { usages, isLoading } = useContentVariableUsage(variable.id)
  return (
    <Modal.Root open={isOpen} onClose={onClose}>
      <Modal.Dialog size="x-large" variant="info">
        <Modal.Title title={variable.name} />
        <Modal.Content css={{ width: '600px', height: '350px' }}>
          <Skeleton isLoading={isLoading}>
            <Box>
              {!!usages &&
                usages.map((usage) => {
                  return (
                    <Box
                      key={`${usage.id}--${uniqueId()}`}
                      css={{ marginBottom: '$3' }}
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="flex-start"
                        gap={1}
                      >
                        <Icon
                          icon={usage.sourceType === 'PLAYBOOK' ? bot : faCube}
                          height={20}
                        />
                        <Link
                          variant="inline"
                          truncate={true}
                          href={
                            usage.sourceType === 'PLAYBOOK'
                              ? `/playbooks/editor/${usage.sourceId}/visual-builder`
                              : `/playbooks/blocks/editor/${usage.sourceId}/visual-builder`
                          }
                        >
                          {usage.sourceName}
                        </Link>
                        {usage.sourceType === 'PLAYBOOK' && (
                          <StatusBadge
                            variant={
                              usage.sourceStatus === 'ENABLED'
                                ? 'success'
                                : 'error'
                            }
                          >
                            {usage.sourceStatus === 'ENABLED' ? 'ON' : 'OFF'}
                          </StatusBadge>
                        )}
                        {!isEmptyOrNil(usage.flowName) && (
                          <StatusBadge
                            variant="success"
                            size="medium"
                          >{`A/B`}</StatusBadge>
                        )}
                      </Flex>
                      <Header
                        variant="h3"
                        dangerouslySetInnerHTML={{
                          __html: parseContentVarStringToHtml(
                            usage.sentence,
                            variable.name
                          ),
                        }}
                      />
                    </Box>
                  )
                })}
            </Box>
          </Skeleton>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => onClose()}>Done</Button>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}

export default ContentVariableUsageModal
